<template>
  <div>
    <h1>Voyage</h1>

    <va-card >
    
      <div class="row align--center">
        <div class="flex xs12 md6">
          <va-input
            :value="term"
            :placeholder="$t('tables.searchByName')"
            @input="search"
            removable
          >
            <va-icon name="fa fa-search" slot="prepend" />
          </va-input>
        </div>

        <div class="flex xs12 md3 offset--md3">
          <va-select
            v-model="perPage"
            :label="$t('tables.perPage')"
            :options="perPageOptions"
            noClear
          />
        </div>
      </div>
      
      
      <va-data-table
        :fields="fields"
        :data="filteredData"
        :per-page="parseInt(perPage)"
      >

      <template slot="created_date" slot-scope="props">
        {{ dataMoment(props.rowData.create_date) }}
      </template>

      <template slot="ended_date" slot-scope="props">
          {{dataMoment(props.rowData.ended_date)}}
      </template>

      <!-- <template>
        <va-popover :message="`${$t('tables.delete')} ${props.rowData.fullName}`" placement="top">
          <va-button @click="remove(props.rowData)" flat small color="gray" icon="fa fa-trash" />
        </va-popover>
      </template> -->

      </va-data-table>
  </va-card>

  </div>

</template>

<script>
import moment from 'moment'

import { debounce } from 'lodash'
import service from "../providers/service";

export default {
  data () {
    return {
      term: null,
      data : [],
      perPage: '6',
      perPageOptions: ['4', '6', '10']
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:created_date',
          title: 'Date de creation',
          sortField: 'created_date'
        }, 
        {
          name: '__slot:ended_date',
          title: 'Date d\'entrée',
          sortField: 'ended_date'
        }
        // ,
        // {
        //   name: '__slot:actions',
        //   dataClass: 'text-right',
        // }
      ]
    },
     filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.data
      }

      return this.data.filter(item => {
        return item.created_date.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
  },
  methods: {

    dataMoment:function name(created_date) {
      return moment(created_date).format('DD/MM/YYYY')
    },

     search: debounce(function (term) {
      this.term = term
    }, 400),

    edit (item) {
      alert('Edit User: ' + JSON.stringify(item))
    },

    remove (item) {

    },

    getListTrips(){
      
      service.getTrips(localStorage.userAccesstoken).then( res => {
        console.log(res);
        if(res.status === 200){
          this.data = res.data;
        }
      })

    }

  },
  mounted(){
    this.getListTrips();
  }
}
</script>

<style lang="scss">
</style>